(function () {
  const ROOT_SELECTOR = '[data-trustpilot-product-swiper]';

  function getNavElements(root) {
    const wrap = root.closest('.testimonials-wrapper');
    if (!wrap) return { nextEl: null, prevEl: null };
    return {
      nextEl: wrap.querySelector('.swiper-btn-next'),
      prevEl: wrap.querySelector('.swiper-btn-prev'),
    };
  }

  function initTrustpilotSwiper(root) {
    if (root.dataset.trustpilotSwiperReady === 'true') return;
    if (typeof FoxTheme === 'undefined' || !FoxTheme.Carousel || !FoxTheme.utils?.getGridColumnGap) return;

    const sliderWrapper = root.querySelector('.testimonials__items');
    if (!sliderWrapper) return;

    const { nextEl, prevEl } = getNavElements(root);
    const columnGap = FoxTheme.utils.getGridColumnGap(root);

    const sliderOptions = {
      slidesPerView: 1,
      spaceBetween: columnGap.mobile,
      pagination: false,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: columnGap.tablet,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: columnGap.tabletLarge,
        },
        1280: {
          slidesPerView: 1,
          spaceBetween: columnGap.desktop,
        },
      },
      loop: true,
      threshold: 2,
    };

    const carousel = new window.FoxTheme.Carousel(root, sliderOptions);
    carousel.init();
    root.dataset.trustpilotSwiperReady = 'true';

    const sectionId = root.dataset.sectionId;
    const wrapper = root.closest('.testimonials-wrapper') || root;
    FoxTheme.a11y.bindSliderFocusManagement(wrapper, () => carousel.slider, { useLoop: true });

    if (nextEl && prevEl) {
      // Manual nav avoids Android focus jumping from buttons to page inputs.
      FoxTheme.a11y.bindSliderNavButtons([prevEl, nextEl], () => carousel.slider);
    }

    if (typeof Shopify !== 'undefined' && Shopify.designMode && sectionId) {
      const onBlockSelect = (e) => {
        if (e.detail.sectionId !== sectionId) return;
        const target = e.target;
        if (!root.contains(target)) return;
        const index = Number(target.dataset.index);
        if (Number.isNaN(index) || !carousel.slider) return;
        carousel.slider.slideToLoop(index);
      };
      document.addEventListener('shopify:block:select', onBlockSelect);
    }
  }

  function waitForFoxTheme(callback, attempt) {
    if (typeof FoxTheme !== 'undefined' && FoxTheme.Carousel && FoxTheme.utils?.getGridColumnGap) {
      callback();
      return;
    }
    if (attempt >= 100) return;
    requestAnimationFrame(() => waitForFoxTheme(callback, attempt + 1));
  }

  function initAll() {
    waitForFoxTheme(() => {
      document.querySelectorAll(ROOT_SELECTOR).forEach(initTrustpilotSwiper);
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
